import { render, staticRenderFns } from "./recordView.vue?vue&type=template&id=4ab627bf&scoped=true&"
import script from "./recordView.vue?vue&type=script&lang=js&"
export * from "./recordView.vue?vue&type=script&lang=js&"
import style0 from "./recordView.vue?vue&type=style&index=0&id=4ab627bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab627bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab627bf')) {
      api.createRecord('4ab627bf', component.options)
    } else {
      api.reload('4ab627bf', component.options)
    }
    module.hot.accept("./recordView.vue?vue&type=template&id=4ab627bf&scoped=true&", function () {
      api.rerender('4ab627bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/externalCall/common/recordView.vue"
export default component.exports